/**
 * Layout constants — web implementation.
 *
 * Snapshot of the viewport at module load, matching the native module's contract.
 * Web UI should prefer CSS media queries over these values; they exist so shared
 * modules that already depend on them keep working.
 */
const viewport = (): { width: number; height: number } => {
  if (typeof window === 'undefined') {
    return { width: 1280, height: 800 };
  }
  return { width: window.innerWidth, height: window.innerHeight };
};

const { width: SCREEN_WIDTH, height: SCREEN_HEIGHT } = viewport();

// Base design dimensions (from design spec/Figma)
const BASE_WIDTH = 375;
const BASE_HEIGHT = 812;

const SCALE_FACTOR = SCREEN_WIDTH / BASE_WIDTH;
const VERTICAL_SCALE_FACTOR = SCREEN_HEIGHT / BASE_HEIGHT;

const IS_IOS = false;
const IS_ANDROID = false;
const IS_TABLET = SCREEN_WIDTH >= 768;

export { SCREEN_WIDTH, SCREEN_HEIGHT, BASE_WIDTH, BASE_HEIGHT, SCALE_FACTOR, VERTICAL_SCALE_FACTOR, IS_IOS, IS_ANDROID, IS_TABLET };
